import React, { useState, useEffect, useRef } from 'react';
import CouponPop from './CouponPop';
import useAuth from '../../../hook/auth';

const Coupon = ({ onClick, premiumFeatures, loading }) => {
  const [visitCount, setVisitCount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const { user } = useAuth() || {}
  const { reloadUserInfo } = user || {}
  const isPremium = (reloadUserInfo?.customAttributes && (JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PREMIUM" || JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PROFESSIONAL") ? true : false);

  useEffect(() => {
    const updateVisitCount = () => {
      const storedVisitCount = localStorage.getItem('visitCount');
      const initialVisitCount = storedVisitCount ? parseInt(storedVisitCount, 10) : 0;
      setVisitCount(initialVisitCount + 1);
      localStorage.setItem('visitCount', initialVisitCount + 1);
    };
    updateVisitCount();
  }, []);

  useEffect(() => {
    const probability = visitCount === 2 ? 0.5 : visitCount === 3 ? 0.75 : visitCount >= 4 ? 1 : 0;
    const random = Math.random();
    setShowPopup(random < probability);
  }, [visitCount]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowPopup(false);
  };

  return isPremium ? null : <CouponPop open={showPopup} onClose={handleClose} user={user} onClick={onClick} premiumFeatures={premiumFeatures} loading={loading}/>
};

export default Coupon;
